import { Link } from 'react-router-dom';
import { LanguageSelect } from '../i18n/LanguageSelect';
import { useI18n } from '../i18n/useI18n';
import KaraokrLogo from './KaraokrLogo';

export function LandingFooter() {
  const { t } = useI18n();

  return (
    <footer className="landing-footer">
      <div className="landing-footer-separator" aria-hidden="true" />
      <div className="landing-footer-inner">
        <div className="landing-footer-brand">
          <KaraokrLogo className="landing-footer-logo" />
          <div className="landing-footer-copy">{t('footer.copyright', { year: new Date().getFullYear() })}</div>
        </div>

        <div className="landing-footer-links">
          <span className="landing-footer-links-title">{t('footer.getStarted')}</span>
          <Link to="/create-room" className="landing-footer-link">{t('common.createRoom')}</Link>
          <Link to="/join-room" className="landing-footer-link">{t('common.joinRoom')}</Link>
          <Link to="/festival" className="landing-footer-link">{t('footer.findEvents')}</Link>
        </div>

        <div className="landing-footer-links">
          <span className="landing-footer-links-title">{t('footer.more')}</span>
          <a href="https://instagram.com/karaokrhq" target="_blank" rel="noopener noreferrer" className="landing-footer-link">{t('footer.instagram')}</a>
          <a href="https://alespace.mataroa.blog/" target="_blank" rel="noopener noreferrer" className="landing-footer-link">Blog</a>
          <Link to="/about" className="landing-footer-link">{t('common.about')}</Link>
        </div>

        <div className="landing-footer-links">
          <span className="landing-footer-links-title">{t('footer.legal')}</span>
          <Link to="/terms" className="landing-footer-link">{t('common.terms')}</Link>
          <Link to="/privacy" className="landing-footer-link">{t('common.privacy')}</Link>
        </div>

        <div className="landing-footer-cta">
          <span className="landing-footer-cta-title">{t('footer.ready')}</span>
          <Link to="/create-room" className="landing-footer-cta-button">{t('footer.createFirstRoom')}</Link>
        </div>
      </div>
      <div className="landing-footer-bottom">
        <LanguageSelect />
      </div>
    </footer>
  );
}
